import { useState } from 'react';

import { GlassBox } from 'components/glassBox/GlassBox';

import CheckedIcon from 'assets/events/icons/checked-icon.svg';

import { STATUS_CONFIG } from './constants';
import { StatusFooter } from './StatusFooter';
import styles from './TaskItem.module.scss';
import { TaskItemProps } from './types';
import { formatCompactNumber } from './utils';
import { VipBadge } from './VipBadge';

const DEFAULT_GRADIENT = 'linear-gradient(to bottom right, #2D5EFF 0%, rgba(45, 94, 255, 0.4) 100%)';

export const TaskItem = ({
  name,
  description,
  imageUrl,
  label,
  currentValue,
  targetValue,
  status,
  endsIn,
  isVip = false,
  isCompleted = false,
  onRegister,
  onClaim,
}: TaskItemProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const { shadowVariant, borderColor } = STATUS_CONFIG[status];
  const gradient = isHovered ? borderColor : DEFAULT_GRADIENT;

  return (
    <div
      className={styles.taskItemWrapper}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <GlassBox
        gradient={gradient}
        borderWidth="1px"
        className="tw-h-[380px] tw-w-[300px] tw-p-[20px]"
        borderRadius="21px"
        shadowVariant={shadowVariant}
      >
        <div className="tw-flex tw-h-full tw-flex-col tw-gap-[10px] tw-font-jost tw-text-white">
          <div
            className="tw-h-[136px] tw-w-full tw-rounded-[10px] tw-bg-[#2D5EFF] tw-bg-cover tw-bg-center"
            style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined}
          />
          <div className="tw-font-regular tw-flex tw-items-center tw-justify-between tw-gap-[8px] tw-text-[16px]">
            <span className="tw-truncate">{label ?? name}</span>
            <div className="tw-flex tw-items-center tw-gap-[8px]">
              <span className="tw-font-regular tw-shrink-0 tw-text-[16px]">
                {formatCompactNumber(currentValue)}/{formatCompactNumber(targetValue)}
              </span>
              <div className="tw-flex tw-h-[30px] tw-w-[30px] tw-items-center tw-justify-center tw-rounded-[5px] tw-bg-[#4E4E4E]">
                {isCompleted ? <img src={CheckedIcon} alt="checked" className="tw-h-[10px]" /> : null}
              </div>
            </div>
          </div>
          <div className="tw-h-[1.5px] tw-w-full tw-bg-[#2D5EFF]" />
          <span className="tw-truncate tw-text-left tw-font-bold">{name}</span>
          <span className="tw-font-regular tw-flex-1 tw-text-left tw-text-[12px]">{description}</span>
          <StatusFooter status={status} endsIn={endsIn} onRegister={onRegister} onClaim={onClaim} />
        </div>

        {isVip && <VipBadge />}
      </GlassBox>
    </div>
  );
};
